module.exports = __webpack_public_path__ + "./Roger_022a3c4a8e0fc6aad6b14f0f8cc181d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Roger.jpg
// module id = 540
// module chunks = 0